module.exports = __webpack_public_path__ + "img/87a84f086200643bd6bc9c88173c9c7e.png";